import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Organization } from '../Organization.js';
import { NewUser } from '../User.js';
export class CreateOrganization extends AutoEncoder {
    organization;
    /**
     * The first (administrator) user of this organization
     */
    user;
    registerCode = null;
}
__decorate([
    field({ decoder: Organization })
], CreateOrganization.prototype, "organization", void 0);
__decorate([
    field({ decoder: NewUser })
], CreateOrganization.prototype, "user", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 24 })
], CreateOrganization.prototype, "registerCode", void 0);
//# sourceMappingURL=CreateOrganization.js.map